import { sendGET, sendPUT, BaseURL, sendDELETE } from "../utils/comm";
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
//import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
//import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
//import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

import styled from "styled-components";

const StyledLabel = styled.div`
  width: 10em;
  display: inline-block;
  margin-right: 1em;
  text-align: right;
  text-transform: capitalize;
`;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const displayColumnsList = [
  //  "lastName",
  //  "firstName",
  "name",
  "organizationName",
  "providerType",
  "email",
  "city",
  "state",
  "zip",
  "country",
  "website",
  "notes",
  "phone",
  "dateValue",
];

const ShowAbsorbPanel = ({
  showAbsorbPanel,
  setShowAbsorbPanel,
  accessCode,
  fetchProviders,
}) => {
  const [text, setText] = useState("");
  return (
    <Dialog
      open={showAbsorbPanel}
      TransitionComponent={Transition}
      keepMountedNO
      onClose={() => setShowAbsorbPanel(false)}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle id="alert-dialog-slide-title">
        {"Paste new-subscriber email text"}
      </DialogTitle>
      <DialogContent>
        <>
          <textarea
            rows={20}
            cols={100}
            autoFocus={true}
            value={text}
            onChange={(e) => {
              e.preventDefault();
              setText(e.target.value);
              //alert("changed value:" + e.target.value);
            }}
          />
          <br />
          <button
            onClick={async (e) => {
              e.preventDefault();
              e.stopPropagation();
              //alert("Text is:" + text);
              let rows = text.split("\n");
              let provider = {};
              for (const row of rows) {
                if (row.indexOf(":") === -1) continue;
                let [line, value] = row.split(": "); // Note the trailing space
                value = value ? value.trim() : "";
                if (line.indexOf("Name") === 0) provider["name"] = value;
                if (line.indexOf("Practice") === 0)
                  provider["organizationName"] = value;
                if (line.indexOf("Specialty") === 0)
                  provider["providerType"] = value;
                if (line.indexOf("Address") === 0) provider["address"] = value;
                if (line.indexOf("City") === 0) provider["city"] = value;
                if (line.indexOf("State") === 0) provider["state"] = value;
                if (line.indexOf("Zip") === 0) provider["zip"] = value;
                if (line.indexOf("Phone") === 0) provider["phone"] = value;
                if (line.indexOf("Email") === 0) provider["email"] = value;
                if (line.indexOf("Website") === 0) provider["website"] = value;
                if (line.indexOf("Message") === 0) provider["notes"] = value;
              }
              alert(
                "provider json:" + JSON.stringify(provider).replace(/,/g, "\n")
              );
              try {
                let response = await sendPUT(
                  `/providers/${accessCode}`,
                  provider
                );
                alert("Response on creation:" + JSON.stringify(response));
                fetchProviders();
              } catch (e) {
                console.log("Failed to create new provider!", e);
                alert("Failed to create new provider!" + e);
              }

              setShowAbsorbPanel(false);
            }}
          >
            Absorb
          </button>
          &nbsp;
        </>
      </DialogContent>
    </Dialog>
  );
};

const ShowEditPanel = ({
  showEditPanel,
  setShowEditPanel,
  provider,
  refresh,
}) => {
  console.log("****** ShowEditPanel:", provider);
  return (
    <Dialog
      open={showEditPanel}
      TransitionComponent={Transition}
      keepMountedNO
      onClose={() => setShowEditPanel(false)}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
        {"Add/Edit Provider"}
      </DialogTitle>
      <DialogContent>
        {displayColumnsList.map((which, idx) => {
          if (which === "dateValue") return <></>; // This is an internal-only field
          return (
            <>
              <StyledLabel>{which}&nbsp;</StyledLabel>
              <input
                autoFocus={idx}
                type="text"
                value={provider[which]}
                onChange={(e) => {
                  e.preventDefault();
                  console.log("changed value:", e.target.value);
                  provider[which] = e.target.value;
                  refresh(false);
                }}
              />
              <br />
            </>
          );
        })}
        <button
          onClick={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            refresh("save");
          }}
        >
          Save
        </button>
        &nbsp;
        <button
          onClick={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            refresh("cancel");
          }}
        >
          Cancel
        </button>
        <br />
      </DialogContent>
    </Dialog>
  );
};

function buildRow(
  labels,
  idx,
  shouldHighlight,
  shouldColor,
  onClick,
  onDelete
) {
  return (
    <div
      style={{
        display: "table-row",
        whiteSpace: "nowrap",
        lineHeight: "1.7em",
        //textTransform: idx > 1 ? "capitalize" : "none",
        fontWeight: shouldHighlight ? "bold" : "normal",
        backgroundColor: shouldColor ? "#e0f4e9" : "white",
        fontSize: "1.6em",
      }}
      key={idx}
    >
      {labels.map((label, inner) => {
        let style = {
          display: "table-cell",
          //textTransform: inner > 1 ? "capitalize" : "none",
          textTransform: idx === 0 ? "capitalize" : "none",
          paddingRight: "1em",
          paddingLeft: "1em",
          textAlign: "left",
        };
        if (inner === 1) style = { ...style, fontFamily: "courier" };
        return (
          <div style={style} key={inner}>
            {inner === 0 && idx !== 0 ? (
              <span
                style={{
                  fontWeight: "100-not-working",
                  fontSize: "1em",
                  color: "green",
                }}
              >
                {" "}
                <span onClick={onDelete}>
                  <FontAwesomeIcon
                    icon={faTrash}
                    style={{ paddingRight: "0.8em" }}
                  />
                </span>
                <span onClick={onClick}>
                  <FontAwesomeIcon icon={faEdit} />
                </span>
              </span>
            ) : (
              label
            )}
          </div>
        );
      })}
    </div>
  );
}

function Providers() {
  const [providers, setProviders] = useState(null);
  const [showEditPanel, setShowEditPanel] = useState(false);
  const [showAbsorbPanel, setShowAbsorbPanel] = useState(false);
  const [activeProvider, setActiveProvider] = useState({});
  const [accessCode, setAccessCode] = useState(
    window.location.href.indexOf("localhost") > -1 ? "komplex" : ""
  );

  const fetchProviders = async () => {
    sendGET(`/providers/${accessCode}`).then((data) => {
      console.log("Got providers:", data);
      setProviders(data);
    });
  };

  useEffect(() => {
    console.log("app: useEffect");
    // Simplify Stakutis' use-case...

    if (!providers && window.location.href.indexOf("localhost") > -1)
      fetchProviders();
  }, [providers]);
  let shouldColor = false;
  let values;
  let rows = [];

  if (!providers) {
    if (accessCode === "") rows.push(<h2> Enter valid access code...</h2>);
    else rows.push(<h2 style={{ textAlign: "center" }}>Loading...</h2>);
  } else
    for (let provider of providers) {
      /* See if we are the first row */
      //console.log("Looking at row:", rows.length);
      shouldColor = !shouldColor;
      if (rows.length === 0) {
        rows.push(
          buildRow(["", ...displayColumnsList], rows.length, true, false)
        );
      }
      values = Object.values(provider);
      // This might be sparse! Uhg...
      values = [""];
      for (let v of displayColumnsList) {
        if (!provider[v]) values.push("");
        else {
          if (v === "dateValue")
            values.push(new Date(Number(provider[v])).toDateString());
          else values.push(provider[v]);
        }
      }
      //console.log("provider:", provider);
      //console.log("Values:", values);
      rows.push(
        buildRow(
          values,
          rows.length,
          false,
          shouldColor,
          () => {
            console.log("Setting active:", provider);
            setActiveProvider({ ...provider });
            setShowEditPanel(true);
          },
          () => {
            console.log("Delete:", provider);
            if (
              window.confirm(
                "Are you sure you want to delete: " +
                  provider.organizationName +
                  "?"
              )
            )
              sendDELETE(`/providers/${accessCode}`, {
                dateValue: provider.dateValue,
              }).then((data) => {
                fetchProviders();
                setActiveProvider({});
                setShowEditPanel(false);
              });
          }
        )
      );
    }
  //);

  return (
    <div style={{ textAlign: "center" }}>
      <ShowEditPanel
        showEditPanel={showEditPanel}
        setShowEditPanel={() => setShowEditPanel(false)}
        provider={activeProvider}
        refresh={async (doUpdate) => {
          setProviders([...providers]);
          if (doUpdate === "save") {
            await sendPUT(`/providers/${accessCode}`, activeProvider);
            fetchProviders();
          }
          if (doUpdate) setShowEditPanel(false);
        }}
      />
      <ShowAbsorbPanel
        showAbsorbPanel={showAbsorbPanel}
        setShowAbsorbPanel={() => setShowAbsorbPanel(false)}
        accessCode={accessCode}
        fetchProviders={fetchProviders}
      />
      <div style={{ backgroundColor: "lightblue" }}>
        Provider Administration
      </div>
      <div>Server: {BaseURL}</div>
      {providers && <div>Count of providers: {providers.length}</div>}
      <StyledLabel>Access Code:&nbsp;</StyledLabel>
      <input
        autoFocus
        type="password"
        value={accessCode}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            fetchProviders();
          }
        }}
        onChange={(e) => {
          e.preventDefault();
          console.log("changed value:", e.target.value);
          setAccessCode(e.target.value.toLowerCase());
        }}
      />{" "}
      <button onClick={fetchProviders}>Retrieve...</button>
      <br />
      <div
        style={{
          display: "table",
          fontSize: "0.5em",
          marginTop: "10px",
        }}
      >
        {rows}
        <br />
      </div>
      <div
        style={{
          marginLeft: "1em",
          fontSize: "12pt",
          width: "100%",
          textAlign: "left",
        }}
      >
        <button
          onClick={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowEditPanel(true);
            setActiveProvider({ firstname: "" });
          }}
        >
          Add...
        </button>
        &nbsp;
        <button
          onClick={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowAbsorbPanel(true);
          }}
        >
          Absorb new provider data
        </button>
        &nbsp;
      </div>
    </div>
  );
}

export default Providers;
